"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Explore = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
/**
 * @internal
 */
exports.Explore = function (_a) {
    var color = _a.color, className = _a.className, width = _a.width, height = _a.height;
    return (react_1.default.createElement("svg", { className: className, width: width !== null && width !== void 0 ? width : 16, height: height !== null && height !== void 0 ? height : 16, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("g", { stroke: color !== null && color !== void 0 ? color : "#B1BECA", fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { strokeWidth: "2", strokeLinecap: "square", d: "M10.5 10V6.667M4.5 10V7.75M7.5 10V3.7" }),
            react_1.default.createElement("circle", { cx: "7.5", cy: "7.5", r: "7" }),
            react_1.default.createElement("path", { strokeLinecap: "round", d: "M15.5 15.5l-3-3" }))));
};
//# sourceMappingURL=Explore.js.map